import { memo } from "react";
import type { TooltipProps } from "@mui/material/Tooltip";
import { StyledTooltip } from "./styled";

const LightTooltip = (props: TooltipProps) => {
  return <StyledTooltip {...props} />;
};

export default memo(LightTooltip);
